export const NAME = 'temporaryuser';

export const REQUEST_TEMPORARY_USER = 'REQUEST_TEMPORARY_USER';
export const RECEIVE_TEMPORARY_USER = 'RECEIVE_TEMPORARY_USER';
export const FAILURE_TEMPORARY_USER = 'FAILURE_TEMPORARY_USER';



// WEBPACK FOOTER //
// ./src/services/tempuser/constants.js